import { SvgIconProps } from './icon-props';

export default function ExclusiveAmenities({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			fill="none"
			viewBox="0 0 32 32"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				clipRule="evenodd"
				d="m29.5961 12.5363-8.94-1.38-4.12-7.85998c-.0491-.0897-.1214-.16454-.2094-.21668-.088-.05213-.1884-.07964-.2906-.07964-.1023 0-.2026.02751-.2906.07964-.088.05214-.1603.12698-.2094.21668l-4.11 7.85998-8.95001 1.38h-.09c-.09236.0302-.17528.0839-.24061.1558s-.11082.1596-.13201.2544c-.02118.0949-.01733.1936.01118.2865.02851.0928.0807.1767.15144.2433l6.42 6.12-1.42 8.75v.09c.00018.0953.0247.189.07122.2722s.11351.1532.19463.2032c.08111.0501.17366.0787.26888.083.09523.0043.18997-.0158.27527-.0584l8.00001-4 8 4h.09c.0907.0283.1872.033.2802.0137.0931-.0193.1797-.062.2517-.124.0721-.062.1271-.1413.16-.2305s.0426-.1852.0281-.2792l-1.32-8.7 6.42-6.12.07-.07c.0554-.0787.09-.1701.1005-.2657s-.0033-.1924-.0402-.2812c-.037-.0889-.0958-.1669-.171-.2269-.0753-.06-.1645-.1-.2593-.1162zm-7.1 6.47-.08.08c-.0419.0607-.0714.129-.0869.201-.0154.0721-.0165.1465-.0031.219l1.27 7.93-7.31-3.65h-.09c-.0649-.0272-.1346-.0412-.205-.0412s-.1401.014-.205.0412l-7.31001 3.65 1.28-7.93v-.11c.00076-.0733-.014-.1459-.04329-.2132-.0293-.0672-.07248-.1274-.12671-.1768l-5.81-5.54 8.10001-1.31c.0855-.0152.1665-.049.2374-.0992.0709-.0501.1298-.1153.1726-.1908l3.75-7.13998 3.75 7.13998.06.08c.0812.1074.1983.182.33.21l8.11 1.27z"
				fill="#000"
				fillRule="evenodd"
			/>
		</svg>
	);
}
